import { FC, useState } from 'react';
import { MainLayout } from '../MainLayout';
import { ContainerDetailsForm } from './ContainerDetailsForm';
import { Button } from '@/components/ui/button';
import { useParams } from 'react-router-dom';
import { trpc } from 'src/trpc';
import { Loader } from 'src/components/Loader';
import { Notes } from 'src/components/Notes';
import { QRCode } from 'src/components/QRCode';
import { useToast } from 'src/components/useToast';

export const ContainerDetailsPage: FC = () => {
  const [isFormValid, setIsFormValid] = useState(false);
  const params = useParams<{ id: string }>();
  const { data, isLoading } = trpc.admin.container.getContainer.useQuery(params.id!);
  const { successToast, errorToast } = useToast();

  const handleSuccess = () => {
    successToast({
      title: 'Container updated',
      description: 'Container details have been successfully updated',
    });
  };

  const handleError = (error: Error) => {
    errorToast({
      title: 'Failed to update container',
      description: error.message || 'An error occurred while updating the container details',
    });
  };

  if (isLoading || !data) {
    return (
      <MainLayout>
        <Loader title="Getting dumpsters" />
      </MainLayout>
    );
  }
  return (
    <MainLayout title="Dumpsters">
      <div className="flex flex-row gap-10">
        <div className="flex flex-col w-1/2 bg-white gap-2 p-6">
          <QRCode
            qrCodeImageUrl={data.qrCodeUrl}
            entityId={data?.friendlyId}
            entityType="Container"
          />
          <ContainerDetailsForm
            container={data}
            onSuccess={handleSuccess}
            onError={handleError}
            onStateChange={(state) => setIsFormValid(state.isValid)}
          >
            <div className="flex flex-row justify-start gap-4">
              <div>
                <Button disabled={!isFormValid} className="w-full text-white" type="submit">
                  Save Changes
                </Button>
              </div>
            </div>
          </ContainerDetailsForm>
        </div>
        <div className="w-1/3">
          <Notes entityId={params.id!} origin="container" />
        </div>
      </div>
    </MainLayout>
  );
};
